<template>
  <div>
    <div id="testi" class="bg-primary px-8 py-6">
      <div
        class="mb-3 text-left text-xl font-semibold overflow-hidden truncate"
      >
        {{ title }}
      </div>
      <div class="flex">
        <div class="flex flex-col justify-center items-center" style="flex: 2;">
          <div
            class="mb-2.5 text-secondary py-1 px-2 bg-primary-shade-1 rounded-full"
          >
            <FontAwesomeIcon icon="stopwatch" />
          </div>
          <span class="text-sm py-2 px-5 bg-primary-shade-1 rounded-full">
            {{ cookingTime }} Minutes
          </span>
        </div>
        <div style="flex: 1;" />
        <div class="flex flex-col justify-center" style="flex: 4;">
          <div class="flex justify-start text-black mb-1">
            <span class="text-base font-medium">Macro Split</span>
          </div>
          <div class="flex justify-between">
            <span class="text-sm">Proteins</span>
            <span class="text-secondary font-semibold text-sm">
              {{ proteins }}%
            </span>
          </div>
          <div class="flex justify-between my-0.5">
            <span class="text-sm">Fats</span>
            <span class="text-secondary font-semibold text-sm">
              {{ fats }}%
            </span>
          </div>
          <div class="flex justify-between">
            <span class="text-sm mr-14">Carbohydrates</span>
            <span class="text-secondary font-semibold text-sm">
              {{ carbohydrates }}%
            </span>
          </div>
        </div>
        <div style="flex: 2;" />
      </div>
      <FontAwesomeIcon
        :icon="['far', 'times-circle']"
        size="2x"
        class="absolute cursor-pointer text-secondary top-4 right-0 mr-3.5"
        @click="$modal.hide('RecipeModal')"
      />
    </div>
    <div class="px-10 py-5">
      <h1 class="text-xl font-semibold">Instructions</h1>
      <div class="w-full my-5">{{ recipeInstructions }}</div>
      <h1 class="text-xl font-semibold">Ingredients</h1>
      <ul id="ingredients" class="my-5">
        <li
          v-for="ingredient in ingredients"
          :key="`${recipe.id}-${ingredient.id}`"
          class="text-gray-600 font-normal"
        >
          {{ ingredient.name }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "RecipeModal",
  components: {},
  props: {
    recipe: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    title() {
      return this.recipe.title;
    },
    cookingTime() {
      return this.recipe.cooking_time;
    },
    proteins() {
      return this.recipe.proteins;
    },
    fats() {
      return this.recipe.fats;
    },
    carbohydrates() {
      return this.recipe.carbohydrates;
    },
    recipeInstructions() {
      return this.recipe.recipe_instructions;
    },
    ingredients() {
      return this.recipe.ingredients;
    }
  },
  data() {
    return {};
  },
  created() {}
};
</script>

<style>
.RecipeModal {
  position: fixed;
  overflow-y: scroll;
  right: 0px;
  left: auto !important;
}

#testi {
  position: -webkit-sticky;
  position: sticky;
  top: 0px;
  z-index: 999;
}
ul#ingredients {
  list-style-type: none;
}

ul#ingredients > li:before {
  content: "-";
  margin-right: 5px;
}
</style>
